import React, { useEffect, useState } from 'react';
import { Badge, TopBar, Spinner } from '../components/ui';
import api from '../api/client';

function Row({ label, value, last }) {
  return (
    <div className="row-between" style={{
      padding: '13px 12px',
      borderBottom: last ? 'none' : '1px solid var(--border)',
      alignItems: 'flex-start',
    }}>
      <span className="muted" style={{ fontSize: 13 }}>{label}</span>
      <span style={{ fontSize: 13.5, fontWeight: 700, maxWidth: '60%', textAlign: 'right' }}>{value}</span>
    </div>
  );
}

// Read-only staff profile shown to a customer (from a booking / candidate).
export default function StaffProfile({ staffId, onClose }) {
  const [s, setS] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/users/staff/${staffId}`)
      .then((d) => { if (alive) setS(d.staff); })
      .catch(() => { if (alive) setS({ error: true }); });
    return () => { alive = false; };
  }, [staffId]);

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: 'var(--bg)' }}>
      <TopBar title="Staff Profile" onClose={onClose} />

      {!s ? (
        <Spinner />
      ) : s.error ? (
        <div className="loading-center"><span className="muted">Could not load this profile.</span></div>
      ) : (
        <div style={{ padding: 20, paddingBottom: 40 }}>
          <div style={{ textAlign: 'center', marginBottom: 18 }}>
            <span className="avatar" style={{
              width: 110, height: 110, margin: '0 auto', background: 'var(--surface)',
              border: '3px solid #fff', boxShadow: 'var(--shadow-card)', fontSize: 34,
            }}>
              {s.photo ? <img src={s.photo} alt={s.name} /> : '👤'}
            </span>
            <h2 style={{ fontSize: 22, fontWeight: 900, marginTop: 12, marginBottom: 0 }}>{s.name}</h2>
            {s.staffId ? <div style={{ fontSize: 13, color: 'var(--primary)', fontWeight: 700, marginTop: 2 }}>{s.staffId}</div> : null}
            <div className="row wrap" style={{ gap: 8, marginTop: 10, justifyContent: 'center' }}>
              {s.verified && <Badge label="✓ KYC Verified" tone="success" />}
              {s.aadhaarVerified && <Badge label="🆔 Aadhaar Verified" tone="info" />}
              {s.rating > 0 && <Badge label={`⭐ ${s.rating}`} tone="warning" />}
            </div>
          </div>

          <div className="card" style={{ padding: 6, marginBottom: 14 }}>
            <Row label="Years of experience" value={s.experienceYears ? `${s.experienceYears} year${s.experienceYears === 1 ? '' : 's'}` : '—'} />
            <Row label="Speciality" value={(s.skills || []).join(', ') || '—'} />
            <Row label="Age" value={s.age || '—'} />
            <Row label="Gender" value={s.gender || '—'} />
            <Row label="Home town" value={s.homeTown || '—'} />
            <Row label="Serves in" value={(s.serviceAreas || []).join(', ') || '—'} last />
          </div>

          {s.bio ? (
            <div className="card" style={{ padding: 12, marginBottom: 14 }}>
              <div style={{ fontSize: 13, fontWeight: 700 }}>About</div>
              <p className="muted" style={{ fontSize: 13.5, lineHeight: 1.55, marginTop: 8, marginBottom: 0 }}>{s.bio}</p>
            </div>
          ) : null}

          <p className="faint center" style={{ fontSize: 11.5, lineHeight: 1.4 }}>
            For your safety, the worker's direct number stays private — interviews &amp; scheduling go through our team.
          </p>
        </div>
      )}
    </div>
  );
}
